import { ResumeRedirect } from "hooks/authHook"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Job Pages
import JobGrid from "../pages/JobPages/JobGrid/index"
import JobDetails from "../pages/JobPages/JobDetails"
import JobCategories from "../pages/JobPages/JobCategories"
import JobList from "../pages/JobPages/JobList"
import ApplyJobs from "../pages/JobPages/ApplyJobs/index"
import CandidateList from "../pages/JobPages/CandidateList"
import CandidateOverview from "../pages/JobPages/CandidateOverview"

// User Pages
import UserList from "../pages/UserPages/UserList"
import UserProfile from "pages/UserPages/UserProfile/user-profile"
import SelfProfile from "pages/UserPages/UserProfile/SelfProfile"

// Brand Pages
import BrandList from "../pages/BrandPages/BrandList"

// Stock Pages
import StockList from "pages/StockPages/StockList"
import StockAddEdit from "pages/StockPages/StockList/StockAddEdit"
import StockView from "pages/StockPages/StockView"

// Other Pages
import ModelList from "../pages/ModelPages/ModelList"
import LocationList from "pages/LocationPages/LocationList"
import StatusList from "pages/StatusPages/StatusList"
import ColorList from "pages/ColorPages/ColorList"
import FeatureList from "pages/FeaturePages/FeatureList"
import PackageList from "pages/PackagePages/PackageList"
import YearList from "pages/YearPages/YearList"
import EngineCcList from "pages/EngineCcPages/EngineCcList"
import ChassisCodeList from "pages/ChassisCodePages/ChassisCodeList"
import EngineCodeList from "pages/EngineCodePages/EngineCodeList"
import FuelTypeList from "pages/FuelTypePages/FuelTypeList"
import EngineTypeList from "pages/EngineTypePages/EngineTypeList"
import KeyTypeList from "pages/KeyTypePages/KeyTypeList"
import AuctionGradeList from "pages/AuctionGradePages/AuctionGradeList"
import TransmissionList from "pages/TransmissionPages/TransmissionList"
import ShowroomList from "pages/ShowroomPages/ShowroomList"
import ShowroomProfile from "pages/ShowroomPages/ShowroomProfile"

// Employee Pages
import EmployeeList from "pages/EmployeePages/EmployeeList"
import EmployeeProfile from "pages/EmployeePages/EmployeeProfile"
import EmployeeDepartmentList from "pages/EmployeePages/EmployeeDepartmentList"
import EmployeeDesignationList from "pages/EmployeePages/EmployeeDesignationList"

// Attendance Pages
import AttendanceList from "pages/AttendancePages/AttendanceList"
import MyAttendance from "pages/AttendancePages/MyAttendance"
import AttendanceSettings from "pages/AttendancePages/AttendanceSettings"
import AttendanceMonthlyReport from "pages/AttendancePages/AttendanceMonthlyReport"

// Leave Pages
import LeaveRequestList from "pages/LeavePages/LeaveRequestList"
import LeaveTypeList from "pages/LeavePages/LeaveTypeList"
import HolidayList from "pages/LeavePages/HolidayList"
import LeaveBalancePage from "pages/LeavePages/LeaveBalancePage"
import MyLeave from "pages/LeavePages/MyLeave"

// Contact Form
import MessageList from "pages/ContactFormPages/MessageList"

// Role & Permission
import ModuleList from "pages/RolePermissionPages/ModuleList"
import RoleList from "pages/RolePermissionPages/RoleList"
import PermissionList from "pages/RolePermissionPages/PermissionList"
import RolePermissionList from "pages/RolePermissionPages/RolePermissionList"

// Error Page (404)
import NotFound from "pages/ErrorPages/NotFound"

// Access Permission Constants
import { ACCESS } from "constants/accessPermissions"
import AccessDenied from "pages/ErrorPages/AccessDenied"
import VehicleImporterList from "pages/VehicleImporterPages/VehicleImporterList"
import VehicleImporterAddEdit from "pages/VehicleImporterPages/VehicleImporterList/VehicleImporterAddEdit"
import PostStockList from "pages/ContentManagerPages/PostStockList"
import MovementTypeList from "pages/MovementTypePages/MovementTypeList"
import MovementContainer from "pages/VehicleMovementPages/MovementContainer/MovementContainer"
import VehicleFuelStockList from "pages/VehicleFuelStockPages/VehicleFuelStockList/VehicleFuelStockList"
import VehicleFuelUsageList from "pages/VehicleFuelStockPages/VehicleFuelUsageList/VehicleFuelUsageList"
import CustomerList from "pages/CustomerPages/Customer/CustomerList"
import CustomerProfile from "pages/CustomerPages/CustomerProfile"
import QuotationAddEdit from "pages/QuotationPages/QuotationAddEdit"
import QuotationList from "pages/QuotationPages/QuotationList"
import QuotationView from "pages/QuotationPages/QuotationView"
import CompanyPadList from "pages/CompanyPadPages/CompanyPadList"

// Money Receipt Pages
import MoneyReceiptList from "pages/MoneyReceiptPages/MoneyReceiptListPage"
import MoneyReceiptAddEdit from "pages/MoneyReceiptPages/MoneyReceiptAddEditPage"
import MoneyReceiptView from "pages/MoneyReceiptPages/MoneyReceiptViewPage"

// Pre-Order Pages
import PreOrderList from "pages/PreOrderPages/PreOrderListPage"
import PreOrderView from "pages/PreOrderPages/PreOrderViewPage"
import PreOrderAddEdit from "pages/PreOrderPages/PreOrderAddEditPage"

import AccessoriesList from "pages/AccessoriesPages/AccessoriesList/AccessoriesList"
import AccessoriesView from "pages/AccessoriesPages/AccessoriesList/AccessoriesView"
import AccessoriesCompanyList from "pages/AccessoriesPages/AccessoriesCompany/AccessoriesCompanyList"
import AccessoriesStockList from "pages/AccessoriesPages/AccessoriesStock/AccessoriesStockList"
import UnitList from "pages/UnitPages/UnitList"
import AccessoriesUsageList from "pages/AccessoriesPages/AccessoriesUsage/AccessoriesUsagekList"
import AccessoryUseRequestList from "pages/AccessoriesPages/AccessoryUseRequest/AccessoryUseRequestList"
import CarCareServiceList from "pages/CarCareServicePages/CarCareServiceList"
import CarCareServiceCenterList from "pages/CarCareServiceCenterPages/CarCareServiceCenterList"
import CarCareAccountList from "pages/CarCareAccountPages/CarCareAccountList"
import ServiceInvoiceList from "pages/ServiceInvoicePages/ServiceInvoiceList"
import InventoryList from "pages/InventoryPages/InventoryList/InventoryList"
import InventoryAddEditPage from "pages/InventoryPages/InventoryList/InventoryAddEditPage"
import InventoryViewPage from "pages/InventoryPages/InventoryList/InventoryViewPage"
import InventoryAccessoryList from "pages/InventoryPages/InventoryAccessory/InventoryAccessoryList"
import ImporterView from "pages/VehicleImporterPages/ImporterView/ImporterView"
import PettyCashBillsContainer from "pages/PettyCashPages/PettyCashBill/PettyCashBillsContainer"
import PettyCashPaymentFromList from "pages/PettyCashPages/PettyCashPaymentFrom/PettyCashPaymentFromList"
import PettyCashPaymentModeList from "pages/PettyCashPages/PettyCashPaymentMode/PettyCashPaymentModeList"
import PettyCashPaymentPurposeList from "pages/PettyCashPages/PettyCashPaymentPurpose/PettyCashPaymentPurposeList"
import PettyCashReport from "pages/PettyCashPages/PettyCashReport/PettyCashReport"
import PettyCashBalance from "pages/PettyCashPages/PettyCashBalance/PettyCashBalance"
import AccountBankAccountList from "pages/AccountPages/AccountBankAccount/AccountBankAccountList"
import AccountPaymentMethodList from "pages/AccountPages/AccountPaymentMethod/AccountPaymentMethodList"
import AccountAccountTypeList from "pages/AccountPages/AccountAccountType/AccountAccountTypeList"
import AccountTransactionTypeList from "pages/AccountPages/AccountTransactionType/AccountTransactionTypeList"
import AccountExpenseTypeList from "pages/AccountPages/AccountExpenseType/AccountExpenseTypeList"
import AccountLoanStatusList from "pages/AccountPages/AccountLoanStatus/AccountLoanStatusList"
import AccountBillStatusList from "pages/AccountPages/AccountBillStatus/AccountBillStatusList"
import AccountList from "pages/AccountPages/Account/AccountList"
import AccountVendorList from "pages/AccountPages/AccountVendor/AccountVendorList"
import AccountExpenseList from "pages/AccountPages/AccountExpense/AccountExpenseList"
import AccountCustomerPaymentList from "pages/AccountPages/AccountCustomerPayment/AccountCustomerPaymentList"
import AccountCustomerRefundList from "pages/AccountPages/AccountCustomerRefund/AccountCustomerRefundList"
import AccountVendorBillList from "pages/AccountPages/AccountVendorBill/AccountVendorBillList"
import AccountVendorPaymentList from "pages/AccountPages/AccountVendorPayment/AccountVendorPaymentList"
import AccountLoanList from "pages/AccountPages/AccountLoan/AccountLoanList"
import AccountLoanRepaymentList from "pages/AccountPages/AccountLoanRepayment/AccountLoanRepaymentList"
import AccountTransactionList from "pages/AccountPages/AccountTransaction/AccountTransactionList"
import AccountFundTransferList from "pages/AccountPages/AccountFundTransfer/AccountFundTransferList"
import AccountVehiclePurchaseList from "pages/AccountPages/AccountVehiclePurchase/AccountVehiclePurchaseList"
import AccountImporterPaymentList from "pages/AccountPages/AccountImporterPayment/AccountImporterPaymentList"
import AccountRtgsPaymentList from "pages/AccountPages/AccountRtgsPayment/AccountRtgsPaymentList"
import RtgsBankTemplateList from "pages/AccountPages/RtgsBankTemplate/RtgsBankTemplateList"
import RtgsBankTemplateConfigure from "pages/AccountPages/RtgsBankTemplate/RtgsBankTemplateConfigure"
import AccountDashboard from "pages/AccountPages/AccountDashboard/AccountDashboard"
import AccountDailyReport from "pages/AccountPages/AccountDailyReport/AccountDailyReport"
import AccountDayCloseList from "pages/AccountPages/AccountDayClose/AccountDayCloseList"
import AccountWorkspace from "pages/AccountPages/AccountWorkspace/AccountWorkspace"
import AuditLog from "pages/AccountPages/AuditLog/index"
import ApiStatus from "pages/AccountPages/SystemInfo/ApiStatus"
import ActivityLogPage from "pages/SystemPages/ActivityLog"

const authProtectedRoutes = [
  // 📊 Dashboard
  {
    path: "/dashboard",
    access: [ACCESS.DASHBOARD.VIEW_DASHBOARD],
    component: <Dashboard />,
  },
  {
    path: "/",
    exact: true,
    access: [ACCESS.DASHBOARD.VIEW_DASHBOARD],
    component: <ResumeRedirect />,
  },

  // 👤 User
  {
    path: "/user-list",
    access: [ACCESS.USER.VIEW_USER_LIST],
    component: <UserList />,
  },
  {
    path: "/profile",
    access: [ACCESS.USER.VIEW_PROFILE],
    component: <SelfProfile />,
  },
  {
    path: "/user-list/:identifier/view",
    access: [ACCESS.USER.VIEW_PROFILE],
    component: <UserProfile />,
  },

  // 🚘 Brand
  {
    path: "/brand-list",
    access: [ACCESS.BRAND.VIEW_BRAND_LIST],
    component: <BrandList />,
  },

  // 📦 Model
  {
    path: "/model-list",
    access: [ACCESS.MODEL.VIEW_MODEL_LIST],
    component: <ModelList />,
  },

  // 📍 Location
  {
    path: "/location-list",
    access: [ACCESS.LOCATION.VIEW_LOCATION_LIST],
    component: <LocationList />,
  },

  // 📊 Status
  {
    path: "/status-list",
    access: [ACCESS.STATUS.VIEW_STATUS_LIST],
    component: <StatusList />,
  },

  // 🎨 Color
  {
    path: "/color-list",
    access: [ACCESS.COLOR.VIEW_COLOR_LIST],
    component: <ColorList />,
  },

  // ⚙️ Feature
  {
    path: "/feature-list",
    access: [ACCESS.FEATURE.VIEW_FEATURE_LIST],
    component: <FeatureList />,
  },

  // 📦 Package
  {
    path: "/package-list",
    access: [ACCESS.PACKAGE.VIEW_PACKAGE_LIST],
    component: <PackageList />,
  },

  // 📅 Year
  {
    path: "/year-list",
    access: [ACCESS.YEAR.VIEW_YEAR_LIST],
    component: <YearList />,
  },

  // 🧩 Engine CC
  {
    path: "/engine-cc-list",
    access: [ACCESS.ENGINE_CC.VIEW_ENGINE_CC_LIST],
    component: <EngineCcList />,
  },

  // 🔢 Chassis Code
  {
    path: "/chassis-code-list",
    access: [ACCESS.CHASSIS_CODE.VIEW_CHASSIS_CODE_LIST],
    component: <ChassisCodeList />,
  },

  // 🔧 Engine Code
  {
    path: "/engine-code-list",
    access: [ACCESS.ENGINE_CODE.VIEW_ENGINE_CODE_LIST],
    component: <EngineCodeList />,
  },

  // ⛽ Fuel Type
  {
    path: "/fuel-type-list",
    access: [ACCESS.FUEL_TYPE.VIEW_FUEL_TYPE_LIST],
    component: <FuelTypeList />,
  },

  // 🛠 Engine Type
  {
    path: "/engine-type-list",
    access: [ACCESS.ENGINE_TYPE.VIEW_ENGINE_TYPE_LIST],
    component: <EngineTypeList />,
  },

  // 🔑 Key Type
  {
    path: "/key-type-list",
    access: [ACCESS.KEY_TYPE.VIEW_KEY_TYPE_LIST],
    component: <KeyTypeList />,
  },

  // 🏁 Auction Grade
  {
    path: "/auction-grade-list",
    access: [ACCESS.AUCTION_GRADE.VIEW_AUCTION_GRADE_LIST],
    component: <AuctionGradeList />,
  },

  // ⚙️ Transmission
  {
    path: "/transmission-list",
    access: [ACCESS.TRANSMISSION.VIEW_TRANSMISSION_LIST],
    component: <TransmissionList />,
  },

  // 🏢 Showroom
  {
    path: "/showroom-list",
    access: [ACCESS.SHOWROOM.VIEW_SHOWROOM_LIST],
    component: <ShowroomList />,
  },
  {
    path: "/showroom-list/:slug/view",
    access: [ACCESS.SHOWROOM.VIEW_PROFILE],
    component: <ShowroomProfile />,
  },

  // 👥 Employee
  {
    path: "/employee-list",
    access: [ACCESS.EMPLOYEE.VIEW_LIST],
    component: <EmployeeList />,
  },
  {
    path: "/employee-list/:id/view",
    access: [ACCESS.EMPLOYEE.VIEW],
    component: <EmployeeProfile />,
  },
  {
    path: "/employee-departments",
    access: [ACCESS.EMPLOYEE_DEPARTMENT.VIEW_LIST],
    component: <EmployeeDepartmentList />,
  },
  {
    path: "/employee-designations",
    access: [ACCESS.EMPLOYEE_DESIGNATION.VIEW_LIST],
    component: <EmployeeDesignationList />,
  },

  // 🕒 Attendance
  {
    path: "/attendance",
    access: [ACCESS.ATTENDANCE.VIEW_LIST],
    component: <AttendanceList />,
  },
  {
    path: "/attendance/my",
    access: [ACCESS.ATTENDANCE.CHECK_IN],
    component: <MyAttendance />,
  },
  {
    path: "/attendance/settings",
    access: [ACCESS.ATTENDANCE.VIEW_SETTINGS],
    component: <AttendanceSettings />,
  },
  {
    path: "/attendance/report",
    access: [ACCESS.ATTENDANCE.VIEW_REPORT],
    component: <AttendanceMonthlyReport />,
  },

  // 🍃 Leave
  {
    path: "/leave/requests",
    access: [ACCESS.LEAVE.VIEW_LIST],
    component: <LeaveRequestList />,
  },
  {
    path: "/leave/types",
    access: [ACCESS.LEAVE.MANAGE_TYPES],
    component: <LeaveTypeList />,
  },
  {
    path: "/leave/holidays",
    access: [ACCESS.LEAVE.MANAGE_HOLIDAYS],
    component: <HolidayList />,
  },
  {
    path: "/leave/balances",
    access: [ACCESS.LEAVE.MANAGE_BALANCES],
    component: <LeaveBalancePage />,
  },
  {
    path: "/leave/my",
    access: [ACCESS.LEAVE.VIEW_PANEL],
    component: <MyLeave />,
  },

  // 🚗 Stock
  {
    path: "/stock-list",
    access: [ACCESS.STOCK.VIEW_STOCK_LIST],
    component: <StockList />,
  },
  {
    path: "/stock-add-edit",
    access: [ACCESS.STOCK.CREATE],
    component: <StockAddEdit />,
  },
  {
    path: "/stock-add-edit/:id",
    access: [ACCESS.STOCK.EDIT],
    component: <StockAddEdit />,
  },
  {
    path: "/stock-list/:stockId/view",
    access: [ACCESS.STOCK.VIEW_DETAILS],
    component: <StockView />,
  },

  // 📨 Contact Message
  {
    path: "/message-list",
    access: [ACCESS.MESSAGE.VIEW_CONTACT_MESSAGE_LIST],
    component: <MessageList />,
  },

  // 📨 Movement Type
  {
    path: "/vehicle-movement-type-list",
    access: [ACCESS.VEHICLE_MOVEMENT_TYPE.VIEW_LIST],
    component: <MovementTypeList />,
  },

  // 📨 Vehicle Movement
  {
    path: "/vehicle-movement-list",
    access: [ACCESS.VEHICLE_MOVEMENT.VIEW_LIST],
    component: <MovementContainer />,
  },

  // Vehicle Movement Location
  {
    path: "/movement-location-list",
    access: [ACCESS.LOCATION.VIEW_LOCATION_LIST],
    component: <LocationList />,
  },

  // 🧩 Vehicle Fuel Usage
  {
    path: "/fuel-usage-list",
    access: [ACCESS.VEHICLE_FUEL_USE.VIEW_LIST],
    component: <VehicleFuelUsageList />,
  },
  // 🧩 Vehicle Fuel Stock
  {
    path: "/purchased-fuel-list",
    access: [ACCESS.VEHICLE_FUEL_STOCK.VIEW_LIST],
    component: <VehicleFuelStockList />,
  },
  // 🧩 Fuel Station
  {
    path: "/fuel-station-list",
    access: [ACCESS.LOCATION.VIEW_LOCATION_LIST],
    component: <LocationList />,
  },

  // 🧩 Module
  {
    path: "/module-list",
    access: [ACCESS.MODULE.VIEW_MODULE_LIST],
    component: <ModuleList />,
  },

  // 🔐 Role
  {
    path: "/role-list",
    access: [ACCESS.ROLE.VIEW_ROLE_LIST],
    component: <RoleList />,
  },

  // 🔑 Permission
  {
    path: "/permission-list",
    access: [ACCESS.PERMISSION.VIEW_PERMISSION_LIST],
    component: <PermissionList />,
  },

  // 🧩 Role Permission Assignment
  {
    path: "/role/:roleSlug/permission-list",
    access: [ACCESS.ROLE_PERMISSION.ASSIGN_ROLE_PERMISSIONS],
    component: <RolePermissionList />,
  },

  // 🚘 Vehicle Importer
  {
    path: "/importer-list",
    access: [ACCESS.VEHICLE_IMPORTER.VIEW_VEHICLE_IMPORTER_LIST],
    component: <VehicleImporterList />,
  },
  {
    path: "/importer-list/:identifier/view",
    access: [ACCESS.VEHICLE_IMPORTER.VIEW_VEHICLE_IMPORTER],
    component: <ImporterView />,
  },
  {
    path: "/importer/add",
    access: [ACCESS.VEHICLE_IMPORTER.CREATE_VEHICLE_IMPORTER],
    component: <VehicleImporterAddEdit />,
  },
  {
    path: "/importer/:importerId/edit",
    access: [ACCESS.VEHICLE_IMPORTER.EDIT_VEHICLE_IMPORTER],
    component: <VehicleImporterAddEdit />,
  },
  {
    path: "/importers/:importerId/details",
    access: [ACCESS.VEHICLE_IMPORTER.VIEW_VEHICLE_IMPORTER],
    component: <VehicleImporterList />,
  },

  // 🧠 Content Manager
  {
    path: "/vehicle-content-list",
    access: [ACCESS.CONTENT_MANAGER.VIEW_VEHICLE_CONTENT_LIST],
    component: <PostStockList />,
  },

  // 💼 Job
  {
    path: "/job-grid",
    access: [ACCESS.JOB.VIEW_GRID],
    component: <JobGrid />,
  },
  {
    path: "/job-details",
    access: [ACCESS.JOB.VIEW_DETAILS],
    component: <JobDetails />,
  },
  {
    path: "/job-categories",
    access: [ACCESS.JOB.VIEW_CATEGORIES],
    component: <JobCategories />,
  },
  {
    path: "/job-list",
    access: [ACCESS.JOB.VIEW_GRID],
    component: <JobList />,
  },
  {
    path: "/job-apply",
    access: [ACCESS.JOB.APPLY],
    component: <ApplyJobs />,
  },
  {
    path: "/candidate-list",
    access: [ACCESS.JOB.VIEW_CANDIDATES],
    component: <CandidateList />,
  },
  {
    path: "/candidate-overview",
    access: [ACCESS.JOB.VIEW_CANDIDATE_DETAILS],
    component: <CandidateOverview />,
  },

  /**
  --------------
  -- Customer --
  --------------
  */

  // 🔑 Customer
  {
    path: "/customer-list",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <CustomerList />,
  },
  // Customer Profile
  {
    path: "/customer-list/:identifier/view",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <CustomerProfile />,
  },
  // Quotation Pages
  {
    path: "/quotation-list",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <QuotationList />,
  },
  {
    path: "/quotation-list/add",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <QuotationAddEdit />,
  },
  {
    path: "/quotation-list/:identifier/view",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <QuotationView />,
  },
  {
    path: "/company-pads",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <CompanyPadList />,
  },

  /**
  ---------------------
  -- Money Receipt --
  ---------------------
  */

  // 🧾 Money Receipt List
  {
    path: "/money-receipts",
    access: [ACCESS.MONEY_RECEIPT.VIEW_LIST],
    component: <MoneyReceiptList />,
  },
  // Money Receipt Create
  {
    path: "/money-receipts/create",
    access: [ACCESS.MONEY_RECEIPT.CREATE],
    component: <MoneyReceiptAddEdit />,
  },
  // Money Receipt View
  {
    path: "/money-receipts/:id",
    access: [ACCESS.MONEY_RECEIPT.VIEW],
    component: <MoneyReceiptView />,
  },
  // Money Receipt Edit
  {
    path: "/money-receipts/:id/edit",
    access: [ACCESS.MONEY_RECEIPT.EDIT],
    component: <MoneyReceiptAddEdit />,
  },

  /*
  ---------------------
  -- Pre-Order --
  ---------------------
  */

  // Pre-Order List
  {
    path: "/pre-orders",
    access: [ACCESS.PRE_ORDER.VIEW_LIST],
    component: <PreOrderList />,
  },
  // Pre-Order Create
  {
    path: "/pre-orders/create",
    access: [ACCESS.PRE_ORDER.CREATE],
    component: <PreOrderAddEdit />,
  },
  // Pre-Order View
  {
    path: "/pre-orders/:id",
    access: [ACCESS.PRE_ORDER.VIEW],
    component: <PreOrderView />,
  },
  // Pre-Order Edit
  {
    path: "/pre-orders/:id/edit",
    access: [ACCESS.PRE_ORDER.EDIT],
    component: <PreOrderAddEdit />,
  },
  // Quotation Edit Page
  {
    path: "/quotation-list/:identifier/add",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <QuotationAddEdit />,
  },
  {
    path: "/quotation-list/:identifier/edit",
    access: [ACCESS.CUSTOMER.VIEW_LIST],
    component: <QuotationAddEdit />,
  },

  /**
  -------------------------------------
  -- Accessories Pages --
  -------------------------------------
   */
  {
    path: "/accessories-list",
    access: [ACCESS.ACCESSORIES.VIEW_LIST],
    component: <AccessoriesList />,
  },
  {
    path: "/accessories-list/:id/view",
    access: [ACCESS.ACCESSORIES.VIEW_LIST],
    component: <AccessoriesView />,
  },
  {
    path: "/accessories-store-list",
    access: [ACCESS.ACCESSORIES_COMPANY.VIEW_LIST],
    component: <AccessoriesCompanyList />,
  },
  {
    path: "/accessories-stock-list",
    access: [ACCESS.ACCESSORIES_STOCK.VIEW_LIST],
    component: <AccessoriesStockList />,
  },
  {
    path: "/accessories-usage-list",
    access: [ACCESS.ACCESSORIES_USAGE.VIEW_LIST],
    component: <AccessoriesUsageList />,
  },
  {
    path: "/accessory-use-requests",
    access: [ACCESS.ACCESSORY_USE_REQUEST.VIEW_LIST],
    component: <AccessoryUseRequestList />,
  },
  {
    path: "/car-care-services",
    access: [ACCESS.CAR_CARE_SERVICE.VIEW_LIST],
    component: <CarCareServiceList />,
  },
  {
    path: "/service-invoices",
    access: [ACCESS.SERVICE_INVOICE.VIEW_LIST],
    component: <ServiceInvoiceList />,
  },
  {
    path: "/car-care-service-centers",
    access: [ACCESS.CAR_CARE_SERVICE_CENTER.VIEW_LIST],
    component: <CarCareServiceCenterList />,
  },
  {
    path: "/car-care-accounts",
    access: [ACCESS.CAR_CARE_ACCOUNT.VIEW_LIST],
    component: <CarCareAccountList />,
  },
  {
    path: "/vehicle-stock-inventory-list",
    access: [ACCESS.VEHICLE_STOCK_INVENTORY.VIEW_LIST],
    component: <InventoryList showBreadcrumb={true} />,
  },
  {
    path: "/vehicle-stock-inventory-add",
    access: [ACCESS.VEHICLE_STOCK_INVENTORY.ADD],
    component: <InventoryAddEditPage />,
  },
  {
    path: "/vehicle-stock-inventory-edit/:id",
    access: [ACCESS.VEHICLE_STOCK_INVENTORY.EDIT],
    component: <InventoryAddEditPage />,
  },
  {
    path: "/vehicle-stock-inventory-list/:id/view",
    access: [ACCESS.VEHICLE_STOCK_INVENTORY.VIEW],
    component: <InventoryViewPage />,
  },
  {
    path: "/inventory-accessory-list",
    access: [ACCESS.INVENTORY_ACCESSORY.VIEW_LIST],
    component: <InventoryAccessoryList />,
  },
  /**
  -------------------------------------
  -- Petty Cash Pages --
  -------------------------------------
*/
  {
    path: "/petty-cash-payment-from-list",
    access: [ACCESS.PETTY_CASH_PAYMENT_FROM.VIEW_LIST],
    component: <PettyCashPaymentFromList />,
  },
  {
    path: "/petty-cash-payment-mode-list",
    access: [ACCESS.PETTY_CASH_PAYMENT_MODE.VIEW_LIST],
    component: <PettyCashPaymentModeList />,
  },
  {
    path: "/petty-cash-payment-purpose-list",
    access: [ACCESS.PETTY_CASH_PAYMENT_PURPOSE.VIEW_LIST],
    component: <PettyCashPaymentPurposeList />,
  },
  {
    path: "/petty-cash-transaction-list",
    access: [ACCESS.PETTY_CASH_TRANSACTION.VIEW_LIST],
    component: <PettyCashBillsContainer />,
  },
  {
    path: "/petty-cash-reports",
    access: [ACCESS.PETTY_CASH_REPORT.VIEW_LIST],
    component: <PettyCashReport />,
  },
  {
    path: "/petty-cash-balance",
    access: [ACCESS.PETTY_CASH_BALANCE.VIEW_LIST],
    component: <PettyCashBalance />,
  },

  /**
  ------------------------------
  -- Unit Pages --
  ------------------------------
  */
  {
    path: "/accessories-unit-list",
    access: [ACCESS.UNIT.VIEW_LIST],
    component: <UnitList />,
  },

  /**
  -------------------------------------
  -- Account Pages (Phase 1 Lookup) --
  -------------------------------------
  */
  {
    path: "/account-payment-method-list",
    access: [ACCESS.ACCOUNT_PAYMENT_METHOD.VIEW_LIST],
    component: <AccountPaymentMethodList />,
  },
  {
    path: "/account-bank-account-list",
    access: [ACCESS.ACCOUNT_BANK_ACCOUNT.VIEW_LIST],
    component: <AccountBankAccountList />,
  },
  {
    path: "/account-account-type-list",
    access: [ACCESS.ACCOUNT_ACCOUNT_TYPE.VIEW_LIST],
    component: <AccountAccountTypeList />,
  },
  {
    path: "/account-transaction-type-list",
    access: [ACCESS.ACCOUNT_TRANSACTION_TYPE.VIEW_LIST],
    component: <AccountTransactionTypeList />,
  },
  {
    path: "/account-expense-type-list",
    access: [ACCESS.ACCOUNT_EXPENSE_TYPE.VIEW_LIST],
    component: <AccountExpenseTypeList />,
  },
  {
    path: "/account-loan-status-list",
    access: [ACCESS.ACCOUNT_LOAN_STATUS.VIEW_LIST],
    component: <AccountLoanStatusList />,
  },
  {
    path: "/account-bill-status-list",
    access: [ACCESS.ACCOUNT_BILL_STATUS.VIEW_LIST],
    component: <AccountBillStatusList />,
  },
  {
    path: "/account-list",
    access: [ACCESS.ACCOUNT.VIEW_LIST],
    component: <AccountList />,
  },
  {
    path: "/account-vendor-list",
    access: [ACCESS.ACCOUNT_VENDOR.VIEW_LIST],
    component: <AccountVendorList />,
  },
  {
    path: "/account-expense-list",
    access: [ACCESS.ACCOUNT_EXPENSE.VIEW_LIST],
    component: <AccountExpenseList />,
  },
  {
    path: "/account-rtgs-payment-list",
    access: [ACCESS.ACCOUNT_RTGS_PAYMENT.VIEW_LIST],
    component: <AccountRtgsPaymentList />,
  },
  {
    path: "/rtgs-bank-template-list",
    access: [ACCESS.RTGS_BANK_TEMPLATE.VIEW_LIST],
    component: <RtgsBankTemplateList />,
  },
  {
    path: "/rtgs-bank-template/:id/configure",
    access: [ACCESS.RTGS_BANK_TEMPLATE.EDIT],
    component: <RtgsBankTemplateConfigure />,
  },
  {
    path: "/account-customer-payment-list",
    access: [ACCESS.ACCOUNT_CUSTOMER_PAYMENT.VIEW_LIST],
    component: <AccountCustomerPaymentList />,
  },
  {
    path: "/account-customer-refund-list",
    access: [ACCESS.ACCOUNT_CUSTOMER_REFUND.VIEW_LIST],
    component: <AccountCustomerRefundList />,
  },
  {
    path: "/account-vendor-bill-list",
    access: [ACCESS.ACCOUNT_VENDOR_BILL.VIEW_LIST],
    component: <AccountVendorBillList />,
  },
  {
    path: "/account-vendor-payment-list",
    access: [ACCESS.ACCOUNT_VENDOR_PAYMENT.VIEW_LIST],
    component: <AccountVendorPaymentList />,
  },
  {
    path: "/account-loan-list",
    access: [ACCESS.ACCOUNT_LOAN.VIEW_LIST],
    component: <AccountLoanList />,
  },
  {
    path: "/account-loan-repayment-list",
    access: [ACCESS.ACCOUNT_LOAN_REPAYMENT.VIEW_LIST],
    component: <AccountLoanRepaymentList />,
  },
  {
    path: "/account-transaction-list",
    access: [ACCESS.ACCOUNT_TRANSACTION.VIEW_LIST],
    component: <AccountTransactionList />,
  },
  {
    path: "/account-fund-transfer-list",
    access: [ACCESS.ACCOUNT_FUND_TRANSFER.VIEW_LIST],
    component: <AccountFundTransferList />,
  },
  {
    path: "/account-vehicle-purchase-list",
    access: [ACCESS.ACCOUNT_VEHICLE_PURCHASE.VIEW_LIST],
    component: <AccountVehiclePurchaseList />,
  },
  {
    path: "/account-importer-payment-list",
    access: [ACCESS.ACCOUNT_IMPORTER_PAYMENT.VIEW_LIST],
    component: <AccountImporterPaymentList />,
  },
  {
    path: "/account-workspace",
    access: [ACCESS.ACCOUNT_MANAGEMENT.VIEW, ACCESS.ACCOUNT_VENDOR_BILL.VIEW_LIST, ACCESS.ACCOUNT_VENDOR_PAYMENT.VIEW_LIST, ACCESS.ACCOUNT_CUSTOMER_PAYMENT.VIEW_LIST, ACCESS.ACCOUNT_LOAN.VIEW_LIST, ACCESS.ACCOUNT_LOAN_REPAYMENT.VIEW_LIST, ACCESS.ACCOUNT_TRANSACTION.VIEW_LIST, ACCESS.ACCOUNT_EXPENSE.VIEW_LIST, ACCESS.ACCOUNT_FUND_TRANSFER.VIEW_LIST, ACCESS.ACCOUNT.VIEW_LIST],
    component: <AccountWorkspace />,
  },
  {
    path: "/account-dashboard",
    access: [ACCESS.ACCOUNT_MANAGEMENT.VIEW],
    component: <AccountDashboard />,
  },
  {
    path: "/account-daily-report",
    access: [ACCESS.ACCOUNT_MANAGEMENT.VIEW],
    component: <AccountDailyReport />,
  },
  {
    path: "/account-day-close-list",
    access: [ACCESS.ACCOUNT_DAY_CLOSE.VIEW_LIST],
    component: <AccountDayCloseList />,
  },
  {
    path: "/audit-log-list",
    access: [ACCESS.ACCOUNT_AUDIT_LOG.VIEW_LIST],
    component: <AuditLog />,
  },
  {
    path: "/api-status",
    access: [ACCESS.ACCOUNT_API_STATUS.VIEW],
    component: <ApiStatus />,
  },
  {
    path: "/activity-log-list",
    access: [ACCESS.ACTIVITY_LOG.VIEW_LIST],
    component: <ActivityLogPage />,
  },

  // ❌ 401 fallback
  {
    path: "401",
    component: <AccessDenied />,
  },
  // ❌ 404 fallback
  {
    path: "*",
    component: <NotFound />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "*", component: <NotFound /> }, // 404 for public pages
]

export { authProtectedRoutes, publicRoutes }
